import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';
import MuiLink, { LinkProps } from '@mui/material/Link';

// eslint-disable-next-line react/display-name
export const LinkBehavior = React.forwardRef<
    HTMLAnchorElement,
    Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
    const { href, ...other } = props;
    // Map href (Material UI) -> to (react-router)
    return <RouterLink ref={ref} to={href} {...other} />;
});

interface LinkRouterProps extends Omit<LinkProps, 'href'> {
    to: string;
    replace?: boolean;
}

export const Link = React.forwardRef<HTMLAnchorElement, LinkRouterProps>(
    function Link(props: LinkRouterProps, ref) {
        return <MuiLink {...props} ref={ref} component={RouterLink} />;
    }
);
